import {
  applyDisplayNameFallbackToMany,
  getPublicProfilesByTournament,
} from "@/lib/users";
import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

export function useTournamentContextPlayers(tournamentId: string) {
  const t = useTranslations();

  const queryKey = useMemo(
    () => ["players", tournamentId] as const,
    [tournamentId],
  );

  return useQuery({
    queryKey,
    queryFn: async () => {
      const players = await getPublicProfilesByTournament(tournamentId);
      return applyDisplayNameFallbackToMany(players, t("common.player"));
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
